import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Toggle } from '@alfa-bank/site-toggle';
import { On } from '@alfa-bank/site-toggle/on';
import { Control } from '@alfa-bank/site-toggle/control';
import { Link } from '@alfa-bank/site-link';
import { MarkdownContainerDesktop as MarkdownContainer } from '@alfa-bank/site-markdown-container/desktop';
import { Text } from '@alfa-bank/site-text-v2';
import { Aligner } from '@alfa-bank/site-aligner';

import { DesktopWrapper as Modal } from '../desktop-wrapper';

import type { TAgreement, IDeps } from './models';
import { Agreement as Component } from './agreement';

export const AgreementDesktop = createWidget<IDeps, TAgreement>({
    Toggle,
    Link,
    MarkdownContainer,
    On,
    Control,
    Modal,
    Text,
    Aligner,
})(Component);
